export const formatPrice = (incomingValue: string, significantDigits: number) => {
  let value = incomingValue.replace(/[^0-9.]/g, '');
  let parts = value.split('.');
  if (parts.length > 2) {
    parts = [parts[0], parts.slice(1).join('')];
  }
  if (parts[1]) {
    parts[1] = parts[1].slice(0, significantDigits);
  }
  value = parts.join('.');
  return '$' + parts.join('.');
};

export const validateInput = (incomingValue: string, significantDigits: number) => {
  const allowed = /^[0-9.$]*$/;
  const currentSignificantDigits = incomingValue.split('.')[1]?.length ?? 0;
  return allowed.test(incomingValue) && currentSignificantDigits <= significantDigits
};
